import { render, staticRenderFns } from "./LanguageEditor.vue?vue&type=template&id=75b8c5a8&scoped=true&"
import script from "./LanguageEditor.vue?vue&type=script&lang=ts&"
export * from "./LanguageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageEditor.vue?vue&type=style&index=0&id=75b8c5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8c5a8",
  null
  
)

export default component.exports